import { toast } from "@/components/ui/use-toast";
import { supabase } from "@/integrations/supabase/client";
import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

const AuthCallback = () => {
	const navigate = useNavigate();
	const [searchParams] = useSearchParams();
	const [error, setError] = useState<string | null>(null);

	useEffect(() => {
		const handleAuthCallback = async () => {
			try {
				// Check if there's an error in the URL (like from an email confirmation)
				const errorDescription = searchParams.get("error_description");
				if (errorDescription) {
					setError(errorDescription);
					toast({
						title: "Authentication Error",
						description: errorDescription,
						variant: "destructive",
					});
					return;
				}

				// Handle the OAuth callback
				const { error } = await supabase.auth.getSession();

				if (error) {
					setError(error.message);
					toast({
						title: "Authentication Error",
						description: error.message,
						variant: "destructive",
					});
					return;
				}

				// Redirect to dashboard on successful authentication
				toast({
					title: "Authentication Successful",
					description: "You have been successfully authenticated.",
				});
				navigate("/");
			} catch (err: any) {
				const errorMessage =
					err.message || "An authentication error occurred";
				setError(errorMessage);
				toast({
					title: "Authentication Error",
					description: errorMessage,
					variant: "destructive",
				});
			}
		};

		handleAuthCallback();
	}, [navigate, searchParams]);

	return (
		<div className="min-h-screen flex items-center justify-center p-4">
			<div className="text-center">
				{error ? (
					<div>
						<h2 className="text-2xl font-semibold text-gray-900 mb-2">
							Authentication Error
						</h2>
						<p className="text-gray-600 mb-4">{error}</p>
						<button
							onClick={() => navigate("/auth")}
							className="text-primary hover:underline">
							Return to login
						</button>
					</div>
				) : (
					<div>
						<h2 className="text-2xl font-semibold text-gray-900 mb-2">
							Completing Authentication
						</h2>
						<p className="text-gray-600">
							Please wait while we complete the authentication
							process...
						</p>
						<div className="mt-4 flex justify-center">
							<div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
						</div>
					</div>
				)}
			</div>
		</div>
	);
};

export default AuthCallback;
